module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('old_password')
    }
  }, [_c('label', {
    attrs: {
      "for": "old-password"
    }
  }, [_vm._v("Huidig wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old_password),
      expression: "old_password"
    }],
    attrs: {
      "type": "password",
      "name": "old_password",
      "id": "old_password"
    },
    domProps: {
      "value": (_vm.old_password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.old_password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('password')
    }
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('passwordConfirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordConfirmation"
    }
  }, [_vm._v("Herhaal nieuw wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_passwordConfirmation),
      expression: "new_passwordConfirmation"
    }],
    attrs: {
      "type": "password",
      "name": "passwordConfirmation",
      "id": "passwordConfirmation"
    },
    domProps: {
      "value": (_vm.new_passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_passwordConfirmation = $event.target.value
      }
    }
  })]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Opslaan")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nieuw wachtwoord "), _c('span', {
    staticClass: "example"
  }, [_vm._v("— minimaal 8 tekens")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bcd7366","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/settings/Password.vue
// module id = Vw6N
// module chunks = 0 1